import { VideoList } from 'features/video-list';

const VideosPage = () => {
  return <VideoList />;
};
export default VideosPage;
